export default{
    sign: {
        index: 'sign-index',
    }
}
